<template>
    <div class="modal fade" id="credito_propuesta">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <button
                        type="button"
                        class="close"
                        data-dismiss="modal"
                        aria-label="Close"
                    >
                        <span aria-hidden="true">&times;</span>
                    </button>
                    <h4 class="modal-title">Simula tu credito!</h4>
                </div>
                <div class="modal-body">
                    <b-card>
                        <b-row>
                            <b-col md="3" class="text-center mb-2">
                                <!-- Imagen principal del vehículo -->
                                <img 
                                :src="returnMainImage(inventarioData)" class="img-fluid" alt="image" />
                            </b-col>
                            <b-col md="9">
                                <div>
                                    <h4 class="m-0">
                                        <i class="fa fa-car"></i>
                                        {{inventarioData.modelorel.marca.name}}
                                        {{inventarioData.modelorel.lineas.name}}
                                        {{inventarioData.modelorel.modelo}}
                                    </h4>
                                    <h5 class="grey-text">
                                    {{inventarioData.modelorel.version.name}}
                                    </h5>
                                    <h5 class="text-red">
                                        $ {{formatPrice(inventarioData.fichatecnica.precio_publicacion)}}
                                    </h5>
                                </div>
                            </b-col>
                        </b-row>
                    </b-card>
                    <div
                        class="form-group col-md-12 col-sm-12 text-center mt-2"
                    >
                        <label class="form-label"
                            ><h6 class="title-modal">
                                Calcula el valor de tu cuota mensual para tu
                                credito de:
                                <h5 class="text-red">
                                    $ {{formatPrice(creditoData.valor_financiar)}}
                                </h5>
                            </h6></label
                        ><br />
                        <div class="btn-group" role="group">
                            <button
                                type="button"
                                @click="mesesSelect = 24"
                                :class="{ active: mesesSelect === 24 }"
                                class="btn btn-outline-primary"
                            >
                                24
                            </button>
                            <button
                                type="button"
                                @click="mesesSelect = 48"
                                :class="{ active: mesesSelect === 48 }"
                                class="btn btn-outline-primary"
                            >
                                48
                            </button>
                            <button
                                type="button"
                                @click="mesesSelect = 60"
                                :class="{ active: mesesSelect === 60 }"
                                class="btn btn-outline-primary"
                            >
                                60
                            </button>
                            <button
                                type="button"
                                @click="mesesSelect = 72"
                                :class="{ active: mesesSelect === 72 }"
                                class="btn btn-outline-primary"
                            >
                                72
                            </button>
                            <button
                                type="button"
                                @click="mesesSelect = 84"
                                :class="{ active: mesesSelect === 84 }"
                                class="btn btn-outline-primary"
                            >
                                84
                            </button>
                        </div>
                    </div>
                    <div class="col-md-12 col-sm-12 text-center">
                        <label class="form-label m-0">
                            Tasas para usados desde el <b>0.8% </b>
                            <h6 class="m-0">
                                Cuota Mensual $ {{ calculateCuotaMensual() }}
                            </h6>
                        </label>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import mainHelper from 'helpers/main-helper'
export default {
    computed: {
        creditoData() {
            return this.$store.state.propuesta.credito_form;
        },
        inventarioData() {
            return this.$store.state.propuesta.inventario; 
        },
    },
    data() {
        return {
            mesesSelect: 84
        };
    },
    methods: {
        formatPrice(number){
            return mainHelper.numberWithDots(number);
        },
        returnMainImage(data){
            var image_source = '/assets/images/preview.jpg';
            switch (data.fichatecnica.tipo_plan) {
                case 'gratis':
                    image_source = data.fichatecnica.inspeccion_mecanica.fotos[0];
                    break;
                case 'pagada':
                    image_source = data.fichatecnica.inspeccion.fotosvideo.fotos[0];
                    break;
            }
            return image_source;
        },
        calculateCuotaMensual() {
            var monto = this.creditoData.valor_financiar;
            var tasa = 1.2;
            var tasa = tasa / 100.0;
            var cuota =
                monto *
                ((tasa * Math.pow(1 + tasa, this.mesesSelect)) /
                    (Math.pow(1 + tasa, this.mesesSelect) - 1));
            cuota = cuota.toFixed(0);
            var toInt = parseInt(cuota);
            return toInt.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        }
    }
};
</script>

<style lang="scss">
h5.text-red {
    color: #fa2837;
}
h6.title-modal {
    color: #777777;
}
</style>
